import { render, staticRenderFns } from "./PlatformBilling.vue?vue&type=template&id=73e0377c&scoped=true&"
import script from "./PlatformBilling.vue?vue&type=script&lang=js&"
export * from "./PlatformBilling.vue?vue&type=script&lang=js&"
import style0 from "./PlatformBilling.vue?vue&type=style&index=0&id=73e0377c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e0377c",
  null
  
)

export default component.exports